var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticStyle: { "padding-top": "20px", "padding-left": "50px" } },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleTabClick },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "系统配置", name: "systemInfoConfig" } },
            [
              _vm.activeName === "systemInfoConfig"
                ? _c("system-info-config")
                : _vm._e(),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "参数管理", name: "paramsEnvConfig" } },
            [
              _c("el-alert", {
                staticClass: "title",
                attrs: {
                  closable: false,
                  title:
                    "系统会自动根据拼接的参数记录控制问卷题目或确认问卷结果归属。例子：https://XXXXXX?code=[code]&orderid=[orderid]&products=[products]&province=[province]&city=[city]",
                  type: "info",
                },
              }),
              _c(
                "el-form",
                {
                  staticClass: "form",
                  staticStyle: { "margin-top": "20px" },
                  attrs: { disabled: "" },
                },
                _vm._l(_vm.paramDos, function (item, index) {
                  return _c(
                    "el-col",
                    { key: index },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "page-select--item middle" },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "请选择" },
                              model: {
                                value: item.type,
                                callback: function ($$v) {
                                  _vm.$set(item, "type", $$v)
                                },
                                expression: "item.type",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "门店编码", value: 0 },
                              }),
                              _c("el-option", {
                                attrs: { label: "订单号", value: 1 },
                              }),
                              _c("el-option", {
                                attrs: { label: "菜品编码", value: 2 },
                              }),
                              _c("el-option", {
                                attrs: { label: "省份", value: 3 },
                              }),
                              _c("el-option", {
                                attrs: { label: "城市", value: 4 },
                              }),
                              _c("el-option", {
                                attrs: { label: "会员卡号", value: 5 },
                              }),
                              _c("el-option", {
                                attrs: { label: "用户凭证", value: 6 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { staticClass: "page-select--item middle" },
                        [
                          _c("el-input", {
                            model: {
                              value: item.param,
                              callback: function ($$v) {
                                _vm.$set(item, "param", $$v)
                              },
                              expression: "item.param",
                            },
                          }),
                        ],
                        1
                      ),
                      item.type === 2
                        ? _c(
                            "el-form-item",
                            { staticClass: "page-select--item middle" },
                            [
                              _c(
                                "el-input",
                                {
                                  model: {
                                    value: item.linker,
                                    callback: function ($$v) {
                                      _vm.$set(item, "linker", $$v)
                                    },
                                    expression: "item.linker",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      attrs: { slot: "prepend" },
                                      slot: "prepend",
                                    },
                                    [_vm._v("连接符")]
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }